const root = 'BurnCam Medical';

export default {
	home: `${root}`,
	contact: `${root} `,
	privacy: `${root}  `,
};